export default __webpack_public_path__ + "static/media/i072jk.650ce071.webp";